import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';

const longFormat = 'long';
const numericFormat = 'numeric';
const shortFormat = 'short';
const twoDigitFormat = '2-digit';

const shortDate = {
  day: twoDigitFormat,
  month: twoDigitFormat,
  year: numericFormat
};
const mediumDate = {
  day: numericFormat,
  month: shortFormat,
  year: numericFormat
};
const longDate = {
  day: numericFormat,
  month: longFormat,
  year: numericFormat
};
const longDateTime = {
  day: numericFormat,
  hour: twoDigitFormat,
  minute: twoDigitFormat,
  month: longFormat,
  year: numericFormat
};
const longDateLocalTime = _objectSpread(_objectSpread({}, longDateTime), {}, {
  timeZoneName: 'short'
});
const fullDate = {
  day: numericFormat,
  month: longFormat,
  weekday: longFormat,
  year: numericFormat
};
const time = {
  hour: twoDigitFormat,
  minute: twoDigitFormat
};
const localTime = _objectSpread(_objectSpread({}, time), {}, {
  timeZoneName: 'short'
});

var datetime = /*#__PURE__*/Object.freeze({
    __proto__: null,
    shortDate: shortDate,
    mediumDate: mediumDate,
    'default': mediumDate,
    longDate: longDate,
    longDateTime: longDateTime,
    longDateLocalTime: longDateLocalTime,
    fullDate: fullDate,
    time: time,
    localTime: localTime
});

const currencyStyle = 'currency';
const decimalStyle = 'decimal';
const percentStyle = 'percent';

const defaultFormat = {
  style: 'decimal'
};
const currency = {
  currency: 'USD',
  currencyDisplay: 'narrowSymbol',
  style: currencyStyle
};
const currencySigned = _objectSpread(_objectSpread({}, currency), {}, {
  signDisplay: 'exceptZero'
});
const currencyScreenReader = _objectSpread(_objectSpread({}, currency), {}, {
  currencyDisplay: 'name',
  minimumFractionDigits: 0,
  useGrouping: false
});
const currencyScreenReaderSigned = _objectSpread(_objectSpread({}, currencyScreenReader), {}, {
  signDisplay: 'exceptZero'
});
const currencyScreenReaderUnsigned = _objectSpread(_objectSpread({}, currencyScreenReader), {}, {
  signDisplay: 'never'
});
const decimal = {
  minimumFractionDigits: 1,
  style: decimalStyle
};
const integer = {
  maximumFractionDigits: 0,
  style: decimalStyle
};
const percent = {
  maximumFractionDigits: 2,
  style: percentStyle
};

var number = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': defaultFormat,
    currency: currency,
    currencySigned: currencySigned,
    currencyScreenReader: currencyScreenReader,
    currencyScreenReaderSigned: currencyScreenReaderSigned,
    currencyScreenReaderUnsigned: currencyScreenReaderUnsigned,
    decimal: decimal,
    integer: integer,
    percent: percent
});

export { datetime as dateTime, number };
